import React, {useEffect, useState} from "react";
import {Box, Grid, Snackbar, Typography} from "@material-ui/core";
import {Button, Link, Pagination, Stack} from "@mui/material";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {MUIAutoComplete, MUIDatePicker, MUIInput} from "../../utils/formUtils";
import addressData from "../../data/addressData.json";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Alert} from "@material-ui/lab";
import Spinner from "../../components/Spinner";
import axiosInstance from "../../api";
import {format} from "date-fns";
import {currencyFormat} from "../../utils/fmapUtils";
import _ from "underscore";
import InsertCommentOutlinedIcon from "@mui/icons-material/InsertCommentOutlined";
import CommentsListViewTile from "../agents/CommentsListViewTile";
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import PageviewIcon from '@mui/icons-material/Pageview';
import AdminReferDashboard from "../agents/AdminReferDashboard";
import {useUserContext} from "../../context/UserContext";
const validationSchema = yup.object().shape({});

export default function LeadsListViewTile() {
    const {handleSubmit, control, reset, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const [filterCriteria, setFilterCriteria] = useState({coverageStartDate: null, coverageEndDate: null});
    const [showFilter, setShowFilter] = useState(true);
    const [filterValue, setFilterValue] = useState('** no filters **');
    const [countyList, setCountyList] = useState([]);
    const [matchingLeads, setMatchingLeads] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [errorMessage, setErrorMessage] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showSpinner, setShowSpinner] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({});
    const [cityList, setCityList] = useState([]);
    const [snackbarMessage, setSnackbarMessage] = useState(null);
    const [showTable, setShowTable] = useState(false);
    const [isCommentListViewClicked,setIsCommentListViewClicked] =useState(false);
    const [isReferListViewClicked,setReferListViewClicked] =useState(false);
    const [leadId,setLeadId] = useState();
    const [lead,setLead] = useState();
    const {user,dispatch} = useUserContext();

    useEffect(() => {
        setCountyList(addressData.county);
        setCityList(addressData.city);
    }, []);

    const handleFormChange = (event) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {[event.target.name]: event.target.value}));
    };

    const handleStartDateRange = (startDate) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {'coverageStartDate': startDate}));
    }

    const handleEndDateRange = (endDate) => {
        setFilterCriteria(Object.assign({}, filterCriteria, {'coverageEndDate': endDate}));
    }

    const nullCheck = (value) => _.isNull(value) || _.isUndefined(value) || value === '';

    const onSubmit = data => {
        setSnackbarMessage(null);
        if (nullCheck(data.firstName) && nullCheck(data.lastName) && nullCheck(data.coverageStartDate) && nullCheck(data.coverageEndDate)
            && nullCheck(data.addressLine1) && nullCheck(data.city) && nullCheck(data.county) && nullCheck(data.zip) && nullCheck(data.email) && nullCheck(data.phoneNumber)) {
            setSnackbarMessage('Please select a Search Criteria to proceed.');
            return
        } else {
            if (( !nullCheck(data.coverageStartDate) && nullCheck(data.coverageEndDate)) || ( nullCheck(data.coverageStartDate) && !nullCheck(data.coverageEndDate))) {
                setSnackbarMessage('Please select coverage dates.');
                return
            }
        }
        getMatchingLeads(filterCriteria);

    }

    const handleRecordView = (leadId) => {

    };

    const getRecordsByPageNumber = (pageNumber) => {
        if (searchCriteria) {
            let criteriaWithPageNumber = Object.assign({}, searchCriteria, {pageToShow: pageNumber});
            setSearchCriteria(criteriaWithPageNumber);
            getMatchingLeads(criteriaWithPageNumber);
        }
    }

    const onPageChange = (event, pageNumber) => {
        setCurrentPage(pageNumber);
        getRecordsByPageNumber(pageNumber);
    }

    useEffect(() => {
        let currentFilteredValue = '';
        if (filterCriteria.firstName) {
            currentFilteredValue = 'First Name : ' + filterCriteria.firstName;
        }

        if (filterCriteria.lastName) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Last Name : ' + filterCriteria.lastName;
        }

        if (filterCriteria.addressLine1) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Address Line 1 : ' + filterCriteria.addressLine1;
        }

        if (filterCriteria.city) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'City : ' + filterCriteria.city;
        }

        if (filterCriteria.county) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'County : ' + filterCriteria.county;
        }

        if (filterCriteria.zip) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Zip : ' + filterCriteria.zip;
        }

        if (filterCriteria.email) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Email : ' + filterCriteria.email;
        }

        if (filterCriteria.phoneNumber) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Phone : ' + filterCriteria.phoneNumber;
        }

        if (filterCriteria.coverageStartDate) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Coverage Start Date : ' + format(filterCriteria.coverageStartDate, 'MM/dd/yyyy');
        }

        if (filterCriteria.coverageEndDate) {
            currentFilteredValue = (currentFilteredValue !== '') ? currentFilteredValue + ' , ' : currentFilteredValue;
            currentFilteredValue = currentFilteredValue + 'Coverage End Date : ' +  format(filterCriteria.coverageEndDate, 'MM/dd/yyyy');
        }


        if (currentFilteredValue === '') {
            currentFilteredValue = '** no filters **';
        }
        setFilterValue(currentFilteredValue);
    }, [searchCriteria]);


    const getMatchingLeads = (payload) => {
        setShowSpinner(true);
        axiosInstance.post("unauth/leads/search-leads-by-critieria", payload)
            .then((data) => {
                setErrorMessage(null);
                setSearchCriteria(Object.assign({}, data.searchCriteria));
                if (data.totalResultSetSize && data.totalResultSetSize !== 0 && !isNaN(data.totalResultSetSize) && !isNaN(data.searchCriteria.numberOfRecordsPerPage)) {
                    setPageCount(Math.ceil(data.totalResultSetSize / data.searchCriteria.numberOfRecordsPerPage));
                } else {
                    setPageCount(0);
                }
                if (data && data.resultList && data.resultList.length > 0) {
                    setMatchingLeads([...data.resultList]);
                    setShowTable(true);
                } else {
                    setMatchingLeads([]);
                    setPageCount(0);
                    setShowTable(false);
                }
            })
            .catch((error) => setErrorMessage('An error occurred while retrieving your records'))
            .finally(() => setShowSpinner(false));
    }
    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarMessage(null);
    };

    const setViewDetail = (row) => e => {
        setLead(row);
        let urlVal = process.env.REACT_APP_BASE_URL+'retrieve/'+row?.code;
        window.open(urlVal, "_blank")
    }

    const commentListView = (row) => e => {
        setLeadId(row.leadId);
        setIsCommentListViewClicked(true);
    }

    const setReferListView = (row) => e => {
        setLead(row);
        setReferListViewClicked(true);
    }

    const onReturnBack = () => {
        setReferListViewClicked(false);
        setIsCommentListViewClicked(false);
    }

    if (showSpinner) return <Spinner/>

    return (
        <React.Fragment>
        <>
            {!isCommentListViewClicked  && !isReferListViewClicked &&
            <Box m={2}>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 4, fontWeight: 600}}>
                    Property Quote Search
                </Typography>

                <Typography style={{paddingLeft: 4, marginBottom: 4}}>
                    Filter Leads {!showFilter && <span>&nbsp;&nbsp;<b>{filterValue}</b>&nbsp;</span>} {!showFilter &&
                <Link onClick={() => setShowFilter(!showFilter)}>(show filters)</Link>} {showFilter &&
                <Link onClick={() => setShowFilter(!showFilter)}>(hide filters)</Link>} <Link onClick={() => {
                    setFilterCriteria({
                        firstName: '',
                        lastName: '',
                        addressLine1: '',
                        city: '',
                        county: '',
                        zip: '',
                        email: '',
                        phoneNumber: '', coverageStartDate: null, coverageEndDate: null
                    });
                    reset();
                    setFilterValue('** no filters **');
                    setCurrentPage(1);
                }}>(clear filters)</Link>
                </Typography>

                {showFilter &&
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container alignItems="flex-start" spacing={2} style={{marginBottom: 3}}>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="firstName" defaultValue={filterCriteria?.firstName}
                                      inputPrp={{maxLength: 20}}
                                      value={filterCriteria?.firstName} label="First Name"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="lastName" defaultValue={filterCriteria?.lastName}
                                      inputPrp={{maxLength: 20}}
                                      value={filterCriteria?.lastName} label="Last Name"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="addressLine1" defaultValue={filterCriteria?.addressLine1}
                                      inputPrp={{maxLength: 100}}
                                      value={filterCriteria?.addressLine1} label="Address Line 1"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIAutoComplete id="city" control={control} name="city" label="City" errors={errors}
                                             value={filterCriteria?.city} onValueChange={handleFormChange}
                                             options={cityList}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIAutoComplete id="county" control={control} name="county" label="County"
                                             errors={errors}
                                             value={filterCriteria?.county} onValueChange={handleFormChange}
                                             options={countyList}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="zip" defaultValue={filterCriteria?.zip}
                                      inputPrp={{maxLength: 5}}
                                      value={filterCriteria?.zip} label="ZIP"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="email" defaultValue={filterCriteria?.email}
                                      inputPrp={{maxLength: 50}}
                                      value={filterCriteria?.email} label="Email"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="phoneNumber" defaultValue={filterCriteria?.phoneNumber}
                                      inputPrp={{maxLength: 50}}
                                      value={filterCriteria?.phoneNumber} label="Phone Number"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <MUIDatePicker name="coverageStartDate" control={control}
                                           label="Coverage Need by Start Date"
                                           minDateMessage=""
                                           dateValue={filterCriteria?.coverageStartDate}
                                           handleDateChange={handleStartDateRange}
                                           errors={errors}></MUIDatePicker>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>

                            <MUIDatePicker name="coverageEndDate" control={control} label="Coverage Need by End Date"
                                           minDateMessage=""
                                           dateValue={filterCriteria?.coverageEndDate}
                                           handleDateChange={handleEndDateRange}
                                           errors={errors}></MUIDatePicker>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Button type="submit">Search</Button>
                        </Grid>
                    </Grid>
                </form>
                }

                {showTable && matchingLeads.length === 0 && <><Box component="span" display="flex"
                                                      style={{backgroundColor: "lightblue", marginBottom: 5}} p={2}>
                    No matching leads available for your search criteria.
                </Box>
                    <br/>
                    <br/>
                </>}

                {showTable && matchingLeads.length > 0 &&
                <section>
                    <TableContainer>
                        <Table size="small" aria-label="a dense table">
                            <TableHead style={{backgroundColor: "#1c2438"}}>
                                <TableRow>
                                    <TableCell style={{color: "#ffffff"}}>#</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Property Address</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Consumer Details</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Submit Date</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Need By</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Amount</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Property Type</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Construction Type</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Year</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Status</TableCell>
                                    <TableCell style={{color: "#ffffff"}}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {matchingLeads.map((row, index) => (
                                    <TableRow
                                        key={row.leadId}
                                        sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                    >
                                        <TableCell component="th" scope="row">
                                            {index + 1 + ((currentPage - 1) * 50)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.leadAddressLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.leadContactLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.startDate &&
                                            <span>{format(new Date(row.startDate), 'MM/dd/yyyy')}</span>}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.needByDateLabel &&
                                            <span>{format(new Date(row.needByDateLabel), 'MM/dd/yyyy')}</span>}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {currencyFormat(row.coverageAmount)}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.propertyTypeLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.constructionTypeLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.yearBuilt}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.statusLabel}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Stack direction="row">
                                                <PageviewIcon titleAccess={"Property Quote Details"} onClick={setViewDetail(row)} style={{cursor:"pointer"}}/>&nbsp;&nbsp;
                                                { (row.status === "PENDING" || row.status === "SUBMITTED") && (user.fmapRole === "FMAP_ADMIN" || user.fmapRole === "FMAP_CC_USER")  && <SettingsAccessibilityIcon titleAccess={"Refer Agent"} onClick={setReferListView(row)} style={{cursor:"pointer"}}/>}&nbsp;&nbsp;
                                                <InsertCommentOutlinedIcon titleAccess={"Update Property Comments"} onClick={commentListView(row)} style={{cursor:"pointer"}}/>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {pageCount > 1 &&
                    <Box component="span" justifyContent="center" alignItems="flex-end" display="flex">
                        <Pagination count={pageCount} color="primary" shape="rounded" onChange={onPageChange}
                                    page={currentPage}/>
                    </Box>}
                </section>
                }
                <br/>
                {errorMessage && <Box>
                    <div>
                        <br/>
                        <Alert variant="filled" severity="error">{errorMessage}</Alert>
                    </div>
                </Box>}
                <Snackbar open={snackbarMessage} autoHideDuration={6000} onClose={handleSnackBarClose}>
                    <Alert  variant="filled" onClose={handleSnackBarClose} severity="error">{snackbarMessage}</Alert>
                </Snackbar>
            </Box>}
            {isCommentListViewClicked && !isReferListViewClicked && <Box m={2}>
                <CommentsListViewTile leadId={leadId} onReturnBack={onReturnBack}/>
            </Box>}
            {isReferListViewClicked && !isCommentListViewClicked && <Box m={2}>
                <AdminReferDashboard lead={lead} onReturnBack={onReturnBack}/>
            </Box>}
        </>
        </React.Fragment>
    );
}
